import './index.css'
import React from 'react'
import { Progress as RadixProgress } from 'components/ds'
type Props = React.ComponentProps<typeof RadixProgress>

/**
 * A progress bar component that wraps Radix Progress with customizable appearance options
 * @param value - The progress value as a percentage (0-100)
 * @param size - Size of the progress bar (default: '2')
 * @param color - Color theme for the progress bar (default: 'green')
 * @param variant - Visual variant style (default: 'soft')
 * @param radius - Border radius style (default: 'large')
 * @returns Radix Progress component with specified styling and value
 */
// SLAM-1943: Defaults moved to params because React 19 ignores defaultProps on function components.
const Progress = ({
  value,
  size = '2',
  color = 'green',
  variant = 'soft',
  radius = 'large',
}: Props): React.ReactNode => {
  return (
    <RadixProgress
      value={value}
      size={size}
      color={color}
      variant={variant}
      radius={radius}
    />
  )
}

export default Progress
